/** 直播状态 */
export const LIVE_STATUS = {
    /** 未开播 */
    NOT_START: 1,
    /** 直播中 */
    PLAYING: 2,
    /** 已结束 */
    END: 3,
    /** 已取消 */
    CANCEL: 4,
    /** 已生成回放 */
    GENERATED: 5
}

/** 答题页面路由 */
export const answerPageUrl = ["/home/answerTestPaper", "/home/answerTest"];


/** 试卷状态 */
export const SHIJUAN_STATUS = {
	/** 暂未开放 */
	NOT_OPEN: 1,
	/** 未到开放时间（显示预计开放时间） */
	NOT_REACH_START_TIME: 2,
	/** 开始（考试、练习、背题） */
	STARTING: 3,
	/** 继续（考试、练习、背题） */
	CONTINUE: 4,
	/** 已过期 */
	ENDED: 5,
}


/** 学习模块 */
export const STUDY_MODE = {
	/** 掌分考点 */
	KAODIAN: '1',
	/** 母题再现 */
	MUTI: '2',
	/** 模考题目 */
	MOKAO: '3',
	/** 考前押题 */
	YATI: '4',
	/** 易忘题目 */
	WANGJI: '5',
	/** 易错题目 */
	ERROR: '6',
	/** 获取类型列表 */
	getTypeList() {
		return [
			{ label: '掌分考点', value: this.KAODIAN },
			{ label: '母题再现', value: this.MUTI },
			{ label: '模考题目', value: this.MOKAO },
			{ label: '考前押题', value: this.YATI },
		]
	}
}


/** 考试中的答题模式 */
export const KAOSHI_DATI_MODE = {
	/** 考试模式 */
	KAOSHI: '1',
	/** 练习 */
	LIANXI: '2',
	/** 背题 */
	BEITI: '3',
	/** 获取模式列表 */
	getModeList() {
		return [
			{ label: '考试模式', value: this.KAOSHI },
			{ label: '练习模式', value: this.LIANXI },
			{ label: '背题模式', value: this.BEITI },
		]
	}
}